import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ActivateAlertWrapper = styled.div`
  width: 100%;
  margin: ${Spacing.S12} auto ${Spacing.S24} auto;
  padding: ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
`

export const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 14px;
`
